import React, {FC, useContext} from 'react';
import {Typography} from 'components/Typography';
import classNames from 'classnames';
import style from './style.module.scss';
import {getPluralProducts} from 'core/helpers';
import {SortingSelect} from 'plugins/modules/sorting/components/SortingSelect';
import {ESortingActions} from 'modules/products/providers/CatalogPageProvider/types';
import {ViewSwitcher} from 'modules/products/components/ViewSwitcher';
import {ShowFiltersButtonMobile} from 'plugins/modules/filter/components/ShowFiltersButtonMobile';
import {AppliedFilters} from 'plugins/modules/filter/components/AppliedFilters';
import {FilterContext} from 'plugins/modules/filter/context/new';
import {useListingContext} from 'plugins/modules/listing/context';
import {IProductShort} from 'modules/products/types';
import Icon from 'components/Icon';
import {SkeletonWrapper} from 'modules/skeleton/components/SkeletonWrapper';
import {FilterPickupTodayButtonContext} from 'plugins/modules/filter/context/FilterPickupTodayButtonContext';
import ExpressOrderAppliedFilter from 'plugins/modules/filter/components/AppliedFilters/ExpressOrderAppliedFilter';

interface IProps {
    noBottomOffset?: boolean;
    noTopOffset?: boolean;
}

export const SWITCHER_LIST = [
    {
        hint: 'Краткий режим каталога',
        icon: <Icon icon={'vertical-view'} />,
        value: 'tile',
    },
    {
        hint: 'Подробный режим каталога',
        icon: <Icon icon={'horizontal-view'} />,
        value: 'list',
    },
];

export const CatalogListHeader: FC<IProps> = ({noBottomOffset, noTopOffset}) => {
    const {pagination, handleSort, sortingList, view, handleChangeView} = useListingContext<IProductShort>();
    const {appliedFilters} = useContext(FilterContext);
    const {isFetching} = useListingContext<IProductShort>();
    const {wineShop} = useContext(FilterPickupTodayButtonContext);

    return (
        <>
            <div
                className={classNames(style.productListLayoutControls, {
                    [style.noBottomOffset]: noBottomOffset,
                    [style.noTopOffset]: noTopOffset,
                })}
            >
                <div className={style.leftControlBlock}>
                    <div className={style.showFiltersButtonMobile}>
                        <ShowFiltersButtonMobile />
                    </div>
                    {(0 < appliedFilters.length || wineShop) && (
                        <div className={style.appliedFiltersDesktop}>
                            <AppliedFilters />
                        </div>
                    )}
                    <SkeletonWrapper disabled={!isFetching}>
                        <div className={style.total} data-skeleton-item={true}>
                            <Typography color={'gray60'} variant={'label-14-r-fluid'}>
                                {pagination.totalCount} {getPluralProducts(pagination.totalCount)}
                            </Typography>
                        </div>
                    </SkeletonWrapper>
                </div>
                <div className={style.rightControlBlock}>
                    <SortingSelect<ESortingActions>
                        className={style.productListLayoutFilterSelect}
                        onSortChange={handleSort}
                        sortingList={sortingList}
                        isLoading={isFetching}
                    />
                    <ViewSwitcher
                        className={style.viewSwitcher}
                        onChange={(e) => handleChangeView?.(e.currentTarget.value as 'tile' | 'list')}
                        value={view}
                        list={SWITCHER_LIST}
                    />
                </div>
            </div>
            {wineShop && (
                <div className={style.expressOrderMobile}>
                    <ExpressOrderAppliedFilter />
                </div>
            )}
        </>
    );
};
